import { Injectable } from "@angular/core";
import { AlulaDatabaseService, AlulaResponseData } from "@app/shared/databases/alula.database";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AlulaReceiverBind, AlulaReceiverBindHelper } from "../model/alula-receiver-bind";

@Injectable({
    providedIn: "root",
})
export class AlulaReceiverBindDbService {
    constructor(private databaseService: AlulaDatabaseService) {}

    createAlulaReceiverBind(receiverBind: AlulaReceiverBind): Observable<any> {
        return this.databaseService.createRecord$(AlulaReceiverBindHelper.dbEndpoint, receiverBind).pipe(
            map((bind: AlulaResponseData) => AlulaReceiverBindHelper.fromDbObject(bind)),
            catchError(DataServiceError.handleError())
        );
    }

    updateAlulaReceiverBind(receiverBind: any, id: string): Observable<any> {
        const _receiverBind = AlulaReceiverBindHelper.toDbObject({ ...receiverBind, receiverId: null, receiverGroupId: null });
        return this.databaseService.updateRecord$(AlulaReceiverBindHelper.dbEndpoint, _receiverBind, id).pipe(
            map((alulaReceiverBind: AlulaResponseData) => AlulaReceiverBindHelper.fromDbObject(alulaReceiverBind)),
            catchError(DataServiceError.handleError())
        );
    }

    getAlulaReceiverBinds() {
        return this.databaseService.getRecords$(AlulaReceiverBindHelper.dbEndpoint).pipe(
            map((binds = []) => binds.map(bind => AlulaReceiverBindHelper.fromDbObject(bind))),
            catchError(DataServiceError.handleError())
        );
    }
    getAlulaReceiverBindsByDealerId(dealerId: string) {
        return this.databaseService.getRecords$(AlulaReceiverBindHelper.dbEndpoint, { dealerId }).pipe(
            map((binds = []) => binds.map(bind => AlulaReceiverBindHelper.fromDbObject(bind))),
            catchError(DataServiceError.handleError())
        );
    }

    getAlulaReceiverBindById(id: string) {
        return this.databaseService.getRecord$(AlulaReceiverBindHelper.dbEndpoint, id);
    }

    deleteAlulaReceiverBind(id: string) {
        return this.databaseService.deleteRecord$(AlulaReceiverBindHelper.dbEndpoint, id);
    }
}
